var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 9.5V12.3245L3.88625 11.6428L7.45775 9.5H11C11.8273 9.5 12.5 8.82725 12.5 8V2C12.5 1.17275 11.8273 0.5 11 0.5H2C1.17275 0.5 0.5 1.17275 0.5 2V8C0.5 8.82725 1.17275 9.5 2 9.5H2.75ZM2 2H11V8H7.04225L4.25 9.6755V8H2V2Z",
    fill: "#676767"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenIcon);
export default __webpack_public_path__ + "static/media/open_icon.726884861608ae63e3cdd2f1bc43289f.svg";
export { ForwardRef as ReactComponent };